import { Link } from 'react-router-dom'
import { useAuth } from '../auth/AuthContext'
import { formatVnd, type PayMethod } from '../lib/api'

type Props = {
  value: PayMethod
  onChange: (m: PayMethod) => void
  priceTransfer: number
  priceXu: number
  qty?: number
  methods?: PayMethod[]
}

/** Giá theo phương thức: chuyển khoản & ví gem = giá CK, ví xu = giá xu (như bản gốc). */
export function payTotal(m: PayMethod, priceTransfer: number, priceXu: number, qty = 1) {
  return (m === 'xu' ? priceXu : priceTransfer) * qty
}

export function PayMethodPicker({ value, onChange, priceTransfer, priceXu, qty = 1, methods }: Props) {
  const { user } = useAuth()
  const all: { id: PayMethod; label: string; icon: string; balance?: number; topup?: string }[] = [
    { id: 'bank', label: 'Chuyển khoản', icon: 'fa-solid fa-building-columns' },
    { id: 'gem', label: 'Ví gem', icon: 'fa-regular fa-gem', balance: user?.balance2, topup: '/deposit' },
    { id: 'xu', label: 'Ví xu', icon: 'fa-solid fa-coins', balance: user?.balance, topup: '/deposit?tab=card' },
  ]
  const opts = methods ? all.filter((o) => methods.includes(o.id)) : all

  return (
    <fieldset className="paym">
      <legend>Thanh toán</legend>
      {opts.map((o) => {
        const total = payTotal(o.id, priceTransfer, priceXu, qty)
        const short = user && o.balance != null && o.balance < total
        return (
          <label key={o.id} className={`paym-opt${value === o.id ? ' active' : ''}`}>
            <input
              type="radio"
              name="pay_method"
              value={o.id}
              checked={value === o.id}
              onChange={() => onChange(o.id)}
            />
            <i className={o.icon} aria-hidden />
            <span className="paym-label">
              {o.label}
              {user && o.balance != null ? (
                <small className={short ? 'paym-short' : undefined}>
                  Số dư {o.balance.toLocaleString('vi-VN')}
                  {short && o.topup ? (
                    <>
                      {' · '}
                      <Link to={o.topup}>Nạp thêm</Link>
                    </>
                  ) : null}
                </small>
              ) : null}
            </span>
            <strong className="paym-price">{formatVnd(total)}</strong>
          </label>
        )
      })}
    </fieldset>
  )
}
